/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Dropbox_List_ErrorInputs */

const es_tools_dropbox_list_error = /** @type {(inputs: Tools_Dropbox_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al listar Dropbox`)
};

const en_tools_dropbox_list_error = /** @type {(inputs: Tools_Dropbox_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error listing Dropbox`)
};

/**
* | output |
* | --- |
* | "Error listing Dropbox" |
*
* @param {Tools_Dropbox_List_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_dropbox_list_error = /** @type {((inputs?: Tools_Dropbox_List_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Dropbox_List_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_dropbox_list_error(inputs)
	return en_tools_dropbox_list_error(inputs)
});
export { tools_dropbox_list_error as "tools.dropbox.list_error" }